/**
 * @fileoverview PATCH handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/position" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../../../reactQueryFetcherAdapters";
import { appGroupIdCanvasWorkflowIdStepStepIdPositionCacheKeys } from "./constants";
import type {
  PatchAppGroupIdCanvasWorkflowIdStepStepIdPositionProps,
  PatchCanvasStepPositionResult,
} from "./types";

export const patchCanvasStepPosition = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdPositionCacheKeys,
  ({
    appGroupId,
    workflowId,
    stepId,
    row,
    column,
    isPostLaunchDraft,
  }: PatchAppGroupIdCanvasWorkflowIdStepStepIdPositionProps): Promise<PatchCanvasStepPositionResult> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}/position`,
      "PATCH",
      {
        post_launch_draft: !!isPostLaunchDraft,
        row,
        column,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
